// extracted by mini-css-extract-plugin
export default {"textArea":"AllowedOriginsTextarea-textArea-876140e91ec282f0ada4a4063836c7f3"};